// extracted by mini-css-extract-plugin
export var container = "IllustrationCard-module--container--ZAUb7";
export var copy = "IllustrationCard-module--copy--b038g";
export var image = "IllustrationCard-module--image--yZB3e";
export var title = "IllustrationCard-module--title--pQELB";